import React from 'react';
import { Grid } from '@material-ui/core';
import styled from 'styled-components';
import { DeleteIcon, palette, Typography } from '@dev/ee-components';

export const LoosingFeatureList = styled(Grid)`
    row-gap: 20px;
`;

export const IconWrapper = styled.span`
    margin-right: 16px;
    display: inline-flex;
    align-items: center;
`;
export interface FeatureNotIncludedI {
    list: string[];
    children?: JSX.Element;
}
export const UsedEntitiesList = ({ list, children }: FeatureNotIncludedI) => (
    <Grid container>
        {children}
        <LoosingFeatureList container>
            {list?.map((name, index) => (
                <Grid item xs={12} sm={6} key={`feature-${index}`} container alignItems="center" wrap="nowrap">
                    <IconWrapper>
                        <DeleteIcon color={palette.gray[6]} />
                    </IconWrapper>
                    <Typography variant="body1" style={{ display: 'inline-flex' }}>
                        {name}
                    </Typography>
                </Grid>
            ))}
        </LoosingFeatureList>
    </Grid>
);
